import { useHeaderRowContext } from '../../../HeaderRow/context/hooks/useHeaderRowContext.js';

/**
 * determines the appropriate typography variant based on header context
 * @returns Typography variant based on header context
 */
var useHeaderTitleVariant = function useHeaderTitleVariant() {
  var _useHeaderRowContext = useHeaderRowContext(),
    hasCaption = _useHeaderRowContext.hasCaption,
    hasSearchFieldButton = _useHeaderRowContext.hasSearchFieldButton;
  var titleVariant = hasSearchFieldButton ? 'body-s-strong' : 'heading-default';
  return hasCaption ? 'caption-default-strong' : titleVariant;
};

export { useHeaderTitleVariant };
//# sourceMappingURL=useHeaderTitleVariant.js.map
